import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import { TextField } from '@material-ui/core';
import { Typography, Card, CardContent } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { FormControl } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { Toolbar } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Input, InputLabel } from '@material-ui/core';
import { Select } from '@material-ui/core';
import ErrorView from '~common/components/error-view';
import LoadingView from '~common/components/loading-view';
import MetadataView from '~common/form/metadata-edit-view';
import { PortalTemplate } from '~common/lib/models/portal-template';
import { PortalTemplateType } from '~common/lib/models/portal-template-type';
import { APIError } from '~common/lib/types';
import { MenuItem } from '@material-ui/core';
import RichTextEditor from '~common/components/rich-text-editor';
import Poptart from '~common/components/poptart';

import PortalUser from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';


const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  paper: {
    padding: 30
  },
  heading: {
    marginTop: 30,
    borderBottom: '1px solid #ccc'
  },
  formControl: {
    width: '100%'
  },
  root: {
    width: '100%'
  },
  formField: {
    width: '100%'
  },
  toolbar: {
    justifyContent: 'flex-end'
  },
  headerPaper: {
    padding: 30
  },
  button: {
    marginLeft: 10
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 6,
    position: 'relative',
    flexWrap: 'wrap',
    border: '1px solid #F1F1F1',
    padding: '5px',
    minWidth: '25px',
    height: '20px',
    borderRadius: '2px',
    margin: '0 4px;',
    justifyContent: 'center',
    cursor: 'pointer',
    background: 'white',
    textTransform: 'capitalize'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  templateId: any;
}

type State = {
  template?: PortalTemplate;
  templateTypes: Array<PortalTemplateType>;
  error?: APIError;
  status: 'loading' | 'ready' | 'saving';
  dirty: boolean;
};

class TemplateEditView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
  > {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      dirty: false,
      templateTypes: []
    };
  }

  componentDidMount() {
    if (this.props.templateId == 'new') {
      PortalTemplateType.query({}).then((data) => {
        this.setState({
          templateTypes: data,
          template: new PortalTemplate({}),
          status: 'ready'
        });
      });
    } else {
      Promise.all([
        PortalTemplateType.query({}),
        PortalTemplate.get(this.props.templateId)
      ])
        .then((values) => {
          // if (values && values.length > 1) {
            this.setState({
              templateTypes: (values||[{}])[0],
              template: (values||[{},{}])[1],
              status: 'ready'
            });
          // }
        })
        .catch((err) => {
          this.setState({ error: err });
        });
    }
  }

  handleAttributeChange = (attr: any): any => (event: any): void => {
    if (attr.handleChange) {
      attr.handleChange(event);
      this.setState({});
    }
  };

  handleDateAttributeChange = (attr: string): any => (
    val: any | undefined
  ): void => {
    const { template } = this.state;
    if (template) {
      var event = {
        target: {
          value: val.toDate()
        }
      };
      template[attr].handleChange(event);
      this.setState({ dirty: true });
    }
  };

  handleMetadataChange = (metadata: any) => {
    const { template } = this.state;
    if (template && template['extendedAttributes']) {
      template['extendedAttributes'].value = metadata;
      this.setState({ template });
    }
  };

  handleSaveClick = () => {
    this.setState({ status: 'saving' }, () => {
      if (this.state.template) {
        this.state.template
          .save()
          .then((data) => {
            // this.props.history.goBack();
          })
          .catch((err) => {
            this.setState({ error: err, status: 'ready' });
          });
      } else {
        this.setState({ status: 'ready' });
      }
    });
  };

  cancel = () => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/templates/admin?q=${URLManager.getQueryStringValue(criteria)}`
  }

  render() {
    const { template, error, status } = this.state;
    const { classes }: { classes: ClassNameMap } = this.props;

    var errorView;
    if (error) {
      errorView = <ErrorView classes={{}} error={error} />;
    }

    let view;
    if (status === 'loading') {
      view = <LoadingView classes={{}} />;
    } else if (template) {
      const tt: any = [];

      this.state.templateTypes.forEach((t) => {
        tt.push(
          <MenuItem key={t.key.value} value={t.key.value}>
            {t.title.value}
          </MenuItem>
        );
      });

      var toolbarButtons: Array<any> | undefined = undefined
      if (template.extendedAttributes.value) {
        toolbarButtons = [<TemplateHelpButton onChange={(evt: any) => { }} />]
      }

      view = (
        <div className={classes.container}>
          <Paper className={classes.headerPaper}>
            <Typography className={classes.headerTitle} variant="h6">
              Template Information
            </Typography>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <TextField
                  label="Subject"
                  className={classes.formField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  margin="normal"
                  value={template.title.value || ''}
                  error={template.title.error ? true : false}
                  onChange={this.handleAttributeChange(template.title)}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6}>
                <TextField
                  label="Description"
                  className={classes.formField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  margin="normal"
                  value={template.description.value || ''}
                  error={template.description.error ? true : false}
                  onChange={this.handleAttributeChange(template.description)}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6}>
                <FormControl
                  required
                  margin="normal"
                  className={classes.formControl}>
                  <InputLabel htmlFor="templateType">Template Type</InputLabel>
                  <Select
                    value={
                      template.templateType.value
                        ? template.templateType.value
                        : ''
                    }
                    input={
                      <Input
                        name="templateType"
                        id="templateType"
                        onChange={this.handleAttributeChange(
                          template.templateType
                        )}
                      />
                    }>
                    {tt}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} />
              {template &&
                PortalUser.hasOneOfFeatures(['template_development']) && (
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    <Typography variant="subtitle1">Metadata</Typography>
                    <MetadataView
                      metadata={template.extendedAttributes.value}
                      onMetadataChange={this.handleMetadataChange}
                    />
                  </Grid>
                )}
            </Grid>
            <Grid item lg={12} md={12} sm={12} />
            <Grid item lg={12} md={12} sm={12}>
              <div className={classes.editor}>
                <RichTextEditor
                  toolbarOnFocus
                  toolbarOptions={{
                    options: [
                      'inline',
                      'blockType',
                      'fontSize',
                      'fontFamily',
                      'list',
                      'textAlign',
                      'link',
                      'image',
                      'history'
                    ]
                  }}
                  classes={{}}
                  value={template.templateContents.value || ''}
                  onTextChange={this.handleAttributeChange(
                    template.templateContents
                  )}
                  minHeight={20}
                  // toolbarCustomButtons={toolbarButtons}
                />
              </div>
            </Grid>
          </Paper>
          <Toolbar disableGutters={true} classes={{ root: classes.toolbar }}>
          <Button
              className={classes.button}
              variant="contained"
              onClick={this.cancel}>
              Cancel
            </Button>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              disabled={this.state.status == 'saving'}
              onClick={this.handleSaveClick}>
              Save
            </Button>
          </Toolbar>
        </div>
      );
    }

    return (
      <div className={classes.paper}>
        {errorView}
        {view}
      </div>
    );
  }
}

interface BProps extends React.HTMLProps<HTMLDivElement> {
  onChange?: any;
  editorState?: any;
  replacements?: any;
}

type BState = {};

class templateHelpButton extends React.Component<
  BProps & WithStyles<keyof typeof styles>,
  BState
  > {
  constructor(props: BProps & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {};
  }

  showReplacements = (): void => {
    //const {editorState, onChange} = this.props;
  };

  render() {
    return (
      <Poptart className="poptart"
        click={false}
        placement="top-start"
        icon={"fa fas fa-question"}
        iconStyle={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 6,
          position: 'relative',
          flexWrap: 'wrap',
          border: '1px solid #F1F1F1',
          padding: '5px',
          paddingLeft: '10px',
          paddingRight: '0px',
          minWidth: '25px',
          height: '20px',
          borderRadius: '2px',
          margin: '0 4px',
        }}
        timeout={350}>
        <Card style={{ maxWidth: 350 }}>
          <CardContent>
            <Typography component="p">This document has failed file processing.  Please try again.  If the problem persists:
              <ul>
                <li>Split into separate, smaller files.</li>
                <li>Print the original and scan the pages.</li>
              </ul>
              Remove this item by clicking the remove button below.</Typography>
          </CardContent>
        </Card>
      </Poptart>
      // <div>Hello</div>
    );
  }
}

/* replacements example 
{
  "{{.InvitationURL}}", "Will be replaced with the invitation URL and can be used as a link target for a link",
  "{{.InvitationLink}}", "Will be replaced with a valid link with the text ''.",
}
*/

const TemplateHelpButton = withStyles(styles)(templateHelpButton);

export default withStyles(styles)(TemplateEditView);
